import { FieldViewModel, groupBy, str } from "../../omnia"
import { SatelliteApi } from "../api"

export type State = ReturnType<typeof createState>

export interface Group {
    readonly description: string
    readonly items: GroupItem[]
    readonly active: boolean
}

export interface GroupItem {
    readonly fieldId: number
    readonly description: string
    readonly active: boolean
}

export function createState(api: SatelliteApi) {

    const fields = api.getFields()

    const selection = new Set(api.getBoundaries().filter(f => f.fieldId && (!f.inactive)).map(f => f.fieldId))

    const groups = groupByFieldGroup(fields, selection)

    return {
        api,
        fields,
        selection,
        groups
    }

}

export function getFieldBoundariesStatus(state: State) {
    const { fields, selection } = state
    return fields.map(f => ({ fieldId: f.fieldId, inactive: !selection.has(f.fieldId) }))
}

export function toggleGroup(state: State, group: Group) {

    const { selection } = state

    const active = group.active

    group.items.forEach(item => setSelected(selection, item.fieldId, !active))

    return {
        ...state
    }

}


export function setSelectedFields(state: State, fields: FieldViewModel[]) {

    const { selection } = state

    const fieldIds = (fields || []).map(f => f.fieldId)

    selection.clear()

    for (const id of fieldIds) {
        selection.add(id)
    }

    return { ...state }

}

export function toggleField(state: State, group: Group, item: GroupItem) {

    const { selection } = state

    setSelected(selection, item.fieldId, !item.active)

    return { ...state }

}

function setSelected(set: Set<number>, id: number, selected: boolean) {
    if (selected) {
        set.add(id)
    }
    else {
        set.delete(id)
    }
}

function groupByFieldGroup(fields: FieldViewModel[], selectedFields: Set<number>) {

    const groups = groupBy(fields, f => f.fieldGroup || "")
        .map(g => ({
            fieldGroup: g.key,
            description: g.key || str.NoFieldGroup,
            items: g.values
        }))

    return setupGroups(groups, selectedFields)

}

function setupGroups(from: { fieldGroup: string, description: string, items: FieldViewModel[] }[], selectedFields: Set<number>) {

    let groups = from.map(g => ({

        description: g.description,

        fieldGroup: g.fieldGroup,

        get active() {
            return g.items.some(i => selectedFields.has(i.fieldId))
        },

        set active(value) {
            // Not used, but required by Angular
        },

        items: g.items.map(i => ({

            fieldId: i.fieldId,
            description: i.getCroppingDescription(true, false, false),

            get active() {
                return selectedFields.has(i.fieldId)
            },

            set active(value) {
                // Not used, but required by Angular
            }

        }))

    }))

    groups = groups.sort((a, b) => a.fieldGroup.localeCompare(b.fieldGroup))

    return groups

}

